import CommonRender from '../Refinery/CommonRender';
import { OBJLoader2 } from 'wwobjloader2';


const DEFAULT_MESH_NAME = 'crane.obj';

export type MeshData = {
  vertices: number[];
  normals: number[];
  uvs: number[];
};


export class MeshManager {
  private _meshes: { [key: string]: MeshData };

  constructor() {
    this._meshes = {};
  }

  async init() {
    // load in the default obj
    const defaultMeshString = await CommonRender.fetchOBJFile(DEFAULT_MESH_NAME);
    const meshLoader = new OBJLoader2();
    const parseData = meshLoader.parse(defaultMeshString);

    if (parseData.children <= 0) {
      console.error("no children parsed");
      return;
    }

    // TODO - someday maybe support multiple object groups
    const meshData: MeshData = {
      vertices: parseData.children[0].geometry.attributes.position ? parseData.children[0].geometry.attributes.position.array : [],
      normals: parseData.children[0].geometry.attributes.normal ? parseData.children[0].geometry.attributes.normal.array : [],
      uvs: parseData.children[0].geometry.attributes.uv ? parseData.children[0].geometry.attributes.uv.array : [],
    }
    this.addMeshData(DEFAULT_MESH_NAME, meshData);
  }

  listMeshKeys(): string[] {
    return Object.keys(this._meshes);
  }

  getMeshData(key?: string): MeshData {
    if (!key || !(key in this._meshes)) {
      // TODO - load the bunny by default
      console.warn(`mesh '${key}' not found in mesh manager, defaulting to ${DEFAULT_MESH_NAME}`);
      return this._meshes[DEFAULT_MESH_NAME];
    }
    return this._meshes[key];
  }

  addMeshData(key: string, data: MeshData) {
    if (key in this._meshes) {
      throw new Error(`mesh of key ${key} already exists`);
    }
    this._meshes[key] = data;
  }

  deleteMesh(key: string) {
    if (!key || !(key in this._meshes)) {
      // TODO - load the bunny by default
      throw new Error(`mesh '${key}' not found in mesh manager`);
    }
    delete this._meshes[key];
  }
}